import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { CenterDiv, ImpressumBottom } from '../Div/StyledDiv';
import { ParagraphFontSize } from '../StyledParagraph/StyledParagraph';

export interface IImpressumElement {
    impressumLink: string;
    datenschutzLink: string;
    barrierefreiheitLink: string;
    textColor?: string;
}

const ImpressumLinks = (props: IImpressumElement) => {
    const { t } = useLanguage();
    // const textColor = props.textColor ? props.textColor : '#007bff';

    const links = [
        { href: props.impressumLink, label: t('COMMON', 'Impressum'), key: 'impressum' },
        { href: props.datenschutzLink, label: t('COMMON', 'Datenschutz'), key: 'datenschutz' },
        { href: props.barrierefreiheitLink, label: t('COMMON', 'Barrierefreiheit'), key: 'barrierefreiheit' },
    ].filter((l) => typeof l.href === 'string' && l.href.trim().length > 0);

    if (links.length === 0) {
        return null;
    }

    return (
        <>
            {links.map((link, index) => (
                <React.Fragment key={link.key}>
                    {index > 0 && <span aria-hidden="true"> | </span>}
                    <a href={link.href} target="_blank" rel="noreferrer">
                        {link.label}
                    </a>
                </React.Fragment>
            ))}
        </>
    );
};

const Impressum = (props: IImpressumElement) => {
    const { t } = useLanguage();

    // const textColor = props.textColor ? props.textColor : '#007bff';

    return (
        <ImpressumBottom fontSize={ParagraphFontSize.ExtraSmall}>
            <ImpressumLinks {...props} />
        </ImpressumBottom>
    );
};

export const ImpressumNormal = (props: IImpressumElement) => {
    const { t } = useLanguage();

    // const textColor = props.textColor ? props.textColor : '#007bff';
    return (
        <CenterDiv fontSize={ParagraphFontSize.ExtraSmall}>
            <ImpressumLinks {...props} />
        </CenterDiv>
    );
};

export default Impressum;
